module.exports = "/following_active@2x-07d7498eb401ba7c008758370d2ce77c.png";